// extracted by mini-css-extract-plugin
module.exports = {"dateDottedLine":"cpxP46V8"};